import { helper } from "../../lib/helper";

export const longLeftImageVideo = {
  init(origin, destination, direction, type) {

    // if (type == 'onLeave') {
    //   if (direction == 'down') {
    //     // Background video
    //     longLeftImageVideo.setVideoBg(origin, destination, direction);
    //   }

    //   if (direction == 'up') {
    //     // Background video
    //     longLeftImageVideo.setVideoBg(origin, destination, direction);
    //   }
    // }

    if (type == 'afterLoad') {
      longLeftImageVideo.setLongBackdropBg(origin, destination, direction);

      // if ($('.section.active').next('.section').hasClass('js-backdrop') && $('.section.active').next('.section').hasClass('js-long-left-image-video')) {
      //   $('.js-fp-backdrop .js-long-left-image-video').css('background-image', `url(${$('.section.active').next('.section')})`);
      // }
    }
  },
  // setVideoBg(origin, destination, direction) {
  //   if ($(destination.item).hasClass('js-long-left-image-video') && $(destination.item).hasClass('js-has-video')) {
  //     helper.videoController('play', $('.js-fp-backdrop .js-long-left-image-video video'));
  //   } else {
  //     setTimeout(() => {
  //       helper.videoController('stop', $('.js-fp-backdrop .js-long-left-image-video video'));
  //     }, 1000);
  //   }

  //   /*
  //   if (direction == 'down') {
  //     if ($(destination.item).hasClass('js-long-left-image-video') && $(destination.item).hasClass('js-has-video')) {
  //       helper.videoController('play', $('.js-fp-backdrop .js-long-left-image-video video'));
  //     } else {
  //       setTimeout(() => {
  //         helper.videoController('stop', $('.js-fp-backdrop .js-long-left-image-video video'));
  //       }, 1000);
  //     }
  //   }

  //   if (direction == 'up' && ($(destination.item).hasClass('js-long-left-image-video') && $(destination.item).hasClass('js-has-video')) == false) {
  //     if ($(destination.item).hasClass('js-long-left-image-video') && $(destination.item).hasClass('js-has-video')) {
  //       helper.videoController('play', $('.js-fp-backdrop .js-long-left-image-video video'));
  //     } else {
  //       setTimeout(() => {
  //         helper.videoController('stop', $('.js-fp-backdrop .js-long-left-image-video video'));
  //       }, 1000);
  //     }
  //   }

  //   */
  // },
  setLongBackdropBg(origin, destination, direction) {

    if (direction == 'down') {
      if ($(destination.item).next().hasClass('js-long-left-image-video')) {
        $('.js-fp-backdrop .js-long-left-image-video').removeClass('d-none');
        helper.setLongBackdropBg($(destination.item).next());
      }
    }

    if (direction == 'up') {
      if ($(destination.item).prev().hasClass('js-page-hero-banner')) {
        $('.js-fp-backdrop .js-long-left-image-video').addClass('d-none');
      }
    }
  }
}




// WEBPACK FOOTER //
// ./scripts/components/featured/sustainability/modules/longLeftImageVideo.js